// Application entry point for the Vue 3 + Vuetify 3 marketing site.
//
// Creates the app and registers the Vue Router 4 instance, the Pinia store, and
// the Vuetify 3 plugin, then starts configurable analytics before mounting the
// App.vue shell. initAnalytics stays a no-op until a measurement id is
// configured, so analytics is disabled by default (Requirements 13.1, 13.4, 13.6).
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import pinia from './plugins/pinia'
import vuetify from './plugins/vuetify'
import { initAnalytics } from './analytics'
import runtimeConfig from './config/runtimeConfig'
import { useAuthStore } from './stores/auth'
import 'assets/style.scss'

const app = createApp(App)

app.use(pinia)
app.use(router)
app.use(vuetify)

// Cross-tab session synchronisation (design §8). `pinia-plugin-persistedstate`
// writes the session to localStorage but does not react to changes made in
// other tabs. This `storage` listener bridges that gap: when another tab sets
// or clears the persisted `ts-auth` key, we re-read it here so `isAuthenticated`
// reflects the change within the browser's storage-event latency (well under
// 2 seconds) (Requirements 4.5, 4.6). `event.key === null` fires on
// `localStorage.clear()`, which we also treat as a session change.
window.addEventListener('storage', (event) => {
  if (event.key === 'ts-auth' || event.key === null) {
    useAuthStore().hydrateFromStorage()
  }
})

// Start analytics before mounting so the router's afterEach page-view hook is
// ready for the initial navigation. With no measurement id configured this is a
// no-op that loads no script and records nothing (Requirement 13.6).
initAnalytics(runtimeConfig.analytics.measurementId)

app.mount('#app')
